import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const PERMITIDAS = ["/mis-viajes", "/mi-historial"];
const SOLO_ADMIN = ["/viajes", "/flotilla"];

export default function ChoferGuard({ children }) {
  const { user } = useAuth();
  const { pathname: raw } = useLocation();
  const pathname = raw.replace(/\/+$/, "") || "/";
  const rol = (user?.rol || "").toLowerCase();
  if (rol === "chofer" && !PERMITIDAS.includes(pathname)) return <Navigate to="/mis-viajes" replace />;
  if (rol !== "admin" && SOLO_ADMIN.some((p) => pathname.startsWith(p))) return <Navigate to="/" replace />;
  if (rol !== "chofer" && PERMITIDAS.includes(pathname)) return <Navigate to="/" replace />;
  return children;
}
